<div class="card card--no-padding service service--clickable" [routerLink]="routerLink()">
  <div class="service__header">
    <div class="service__left service__left--no-padding">
      <svg-icon class="service-icon-wireless" src="assets/images/icons/wireless.svg" />

      <div class="service__header-caption">
        <div class="service__title-row">
          <alias-editor
            [customerDescription]="customerDescription()"
            [subscriptionId]="subscriptionId()"
            class="list-alias-editor"
          />
          <div class="service__button" (click)="openIncidentDialog($event)">
            {{ "Services.Fulfilment.ReportProblem" | translate }}
          </div>
        </div>
        <service-subtitle [subscription]="subscription()" />
        <service-tags [firewallEnabled]="false" [tags]="tags()" />

        <div class="service__access-points">
          <div class="service__access-points-item">
            <span>{{ "ServiceElement.APsActive" | translate }}</span>
            <span>
              @if (loading()) {
                <loader [small]="true" [iconOnly]="true" [paddingSize]="'small'"></loader>
              } @else if (hasActiveAps()) {
                {{ activeAps() }}
              } @else {
                -
              }
            </span>
          </div>
          <div class="service__access-points-item">
            <span>{{ "ServiceElement.APsInactive" | translate }}</span>
            <span>
              @if (loading()) {
                <loader [small]="true" [iconOnly]="true" [paddingSize]="'small'"></loader>
              } @else if (hasInactiveAps()) {
                {{ inactiveAps() }}
              } @else {
                -
              }
            </span>
          </div>
          <div class="service__access-points-kpis">
            @switch (sensorPresent()) {
              @case (undefined) {
                <loader [small]="true" [paddingSize]="'small'"></loader>
              }
              @case (true) {
                @if (loading()) {
                  <loader [small]="true" [paddingSize]="'small'"></loader>
                } @else {
                  <kpi-row [healthData]="kpiData()" [vendor]="vendor()"></kpi-row>
                }
              }
              @case (false) {
                <p>{{ "Wireless.Sensor.NoSensor" | translate }}</p>
              }
              @default {
                <p>{{ "Wireless.Sensor.UnknownState" | translate }}</p>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (hasOpenTickets()) {
    <div
      class="service__status-wrapper service__tickets service--blue"
      role="button"
      tabindex="0"
      (click)="openTicketsDialog($event)"
      (keydown.enter)="openTicketsDialog($event)"
      (keydown.space)="openTicketsDialog($event)"
    >
      <div class="service-status__caption" [title]="lastTicketSummary()">
        <span class="service-status__title">{{ "ServiceElement.TicketLabel" | translate }} - {{ lastTicketId() }}</span>
        @if (lastTicketSummary()) {
          <span> - </span>
          <span>{{ lastTicketSummary() }}</span>
        }
      </div>
      <span class="service__tickets-badge">
        <svg-icon src="assets/images/icons/warning.svg"></svg-icon>
        @if (hasMoreTickets()) {
          <span>{{ "ServiceElement.MoreTickets" | translate: { count: moreTicketCount() } }}</span>
        }
      </span>
    </div>
  }
</div>
